import React, { useEffect, useMemo } from 'react';
import { filter } from 'lodash';
import Statuses from '../../../model/Statuses';
import SelectBox from './base/SelectBox';
import useEnumerableModel from '../../data/hooks/useEnumerableModel';
const FormStatusSelector = ({ disabled = false, input: { onChange, value }, isNew = false, meta, options: incomingOptions, defaultValue, required, hasOnlyActiveStatus = false, hasOmitDeleteStatus = false, label = 'Status', withTitle, buttonClassNames, containerClassNames, dataCy, }) => {
    const { options: defaultOptions } = useEnumerableModel(Statuses);
    const options = incomingOptions || defaultOptions;
    const _options = useMemo(() => filter(options, option => {
        const { value } = option;
        if ((isNew || hasOmitDeleteStatus) &&
            value === Statuses.Deleted.value) {
            return false;
        }
        return !(hasOnlyActiveStatus && value !== Statuses.Active.value);
    }), [isNew, hasOmitDeleteStatus, options, hasOnlyActiveStatus]);
    const selectedValue = useMemo(() => (value || meta.dirty || meta.touched ? value : defaultValue), [value, meta, defaultValue]);
    useEffect(() => {
        if (!value && !meta.dirty && !meta.touched && defaultValue) {
            onChange(selectedValue);
        }
    });
    return (<SelectBox formElement buttonClassNames={buttonClassNames} containerClassNames={containerClassNames} dataCy={dataCy} disabled={disabled || meta.submitting} errorMessage={((meta.dirty || meta.touched) && meta.error) || null} options={_options} placeholder={label} required={required} value={selectedValue} withTitle={withTitle} onChange={onChange}/>);
};
export default FormStatusSelector;
